// extracted by mini-css-extract-plugin
export default {"ordersCard":"Placements_ordersCard__T1d8y","googleTasks":"Placements_googleTasks__9jZVL"};